import { isFromDiscoverURL } from "@faire/retailer-visitor-shared/paths/index";
import { useLocation } from "react-router-dom";
export var useSearchPageIsFromDiscoverURL = function() {
    var location = useLocation();
    return isFromDiscoverURL(location.pathname);
};
